import type { CSSProperties } from 'react';
import s from './Logo.module.css';

/** The octagon "C" mark and the caged.gg wordmark (designs/Caged Logo). */
export function Logo({ size = 30, text = true }: { size?: number; text?: boolean }) {
  const style = { '--mark': `${size}px` } as CSSProperties;
  return (
    <span className={s.logo} style={style}>
      <span className={s.mark} aria-hidden="true">
        <span className={s.markShadow} />
        <span className={s.markFace}>C</span>
      </span>
      {text && <span className={s.word}>caged.gg</span>}
    </span>
  );
}
